import { signerIpLabel } from '../../../utils/ip'
import { describeUserAgent } from '../../../utils/userAgent'

const staffSessionLabel = ({ name, role } = {}) => {
  const who = [name, role].filter(Boolean).join(', ')
  return `Signed during a staff session${who ? ` (${who})` : ''}`
}

export const signerEvidenceLines = (signer) => [
  ['IP', signerIpLabel(signer)],
  ['Device', describeUserAgent(signer?.userAgent) || 'Not recorded'],
  signer?.signedVia && ['Channel', signer.signedVia === 'in-session' ? 'Signed in session' : 'Signed via link'],
  signer?.staffSession && ['Staff', staffSessionLabel(signer.staffSession)],
  signer?.typedName && ['Typed name', `${signer.typedName}${signer.typedNameMatches === false ? ' (differs from the contact name)' : ''}`],
  signer?.consent?.version && ['Consent', `Version ${signer.consent.version}`],
  signer?.recipientIsStaff && ['Recipients', 'A staff address was among the recipients'],
  signer?.otp?.verifiedAt && ['Code', `Code verified at ${signer.otp.destinationMasked || 'N/A'}${signer.otp.destinationIsStaff ? ' (a staff address)' : ''}`],
].filter(Boolean)
